import { todayStr, monthStart } from "@/pos/lib/format";

const PRESETS = [
  ["Hari Ini", () => [todayStr(), todayStr()]],
  ["7 Hari", () => [todayStr(-6), todayStr()]],
  ["Bulan Ini", () => [monthStart(), todayStr()]],
];

export default function DateRange({ value, onChange }) {
  const [from, to] = value;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="reports-date-filter">
      {PRESETS.map(([l, fn]) => {
        const [f, t] = fn();
        const on = f === from && t === to;
        return (
          <button key={l} onClick={() => onChange([f, t])} data-testid={`date-preset-${l.replace(/\s/g, "-")}`}
            className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${on ? "bg-[#DC2626] text-white" : "border border-red-100 bg-white text-slate-600 hover:bg-red-50"}`}>{l}</button>
        );
      })}
      <input type="date" value={from} onChange={(e) => onChange([e.target.value, to])} className="h-9 rounded-lg border border-slate-200 bg-white px-2 text-sm" data-testid="date-from-input" />
      <span className="text-slate-400">–</span>
      <input type="date" value={to} onChange={(e) => onChange([from, e.target.value])} className="h-9 rounded-lg border border-slate-200 bg-white px-2 text-sm" data-testid="date-to-input" />
    </div>
  );
}
